import * as React from 'react';

import {Body} from 'shells/typography/body';

type Props = {
    quota: number;
    total: number;
    averageDurationMinutes: string;
};

export function NewActivityTableQuotaHeader(props: Props) {
    return (
        <div className='flex flex-dir-col justify-sb align-end'>
            {props.quota > 0 ? (
                <div>
                    <Body color='dark' size='small'>
                        {props.total}
                    </Body>{' '}
                    <Body color='light' size='small'>
                        / {props.quota}
                    </Body>
                </div>
            ) : (
                <Body color='dark' size='small'>
                    {props.total}
                </Body>
            )}
            <div data-tip='Average time'>
                <Body color='light' size='small'>
                    {props.total > 0 ? props.averageDurationMinutes : '-'}
                </Body>
            </div>
        </div>
    );
}
